import { css } from '@emotion/react';
import { styled, Typography } from '@mui/joy';
import { createFileRoute } from '@tanstack/react-router';

import { ContainerLayout } from '@/components/ContainerLayout';

const LegalHeading = styled(Typography)(
  ({ theme }) => css`
    margin-top: ${theme.spacing(4)};
    margin-bottom: ${theme.spacing(2)};
    font-weight: 700;
  `,
);

const LegalText = styled(Typography)(
  ({ theme }) => css`
    display: block;
    margin-bottom: ${theme.spacing(2)};
  `,
);

function PrivacyRoute() {
  return (
    <ContainerLayout>
      <>
        <Typography level="h1">Information nach Art. 13 bzw. 14 Datenschutz-Grundverordnung (DS-GVO)</Typography>
        <LegalText>
          Das Ministerium für Verkehr verarbeitet im Rahmen der Bereitstellung und des Betriebs des digitalen
          Verkehrszeichenkatasters VZK personenbezogene Daten.
        </LegalText>
        <LegalText>
          Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Mit diesen Hinweisen infor- mieren wir Sie darüber,
          zu welchen Zwecken und auf welcher Rechtsgrundlage wir Ihre personenbezogenen Daten verarbeiten, an wen Sie
          sich in datenschutzrechtlichen Fragen wenden können und welche Rechte Sie nach der DS-GVO haben.
        </LegalText>

        <LegalHeading>1. Wer ist verantwortlich für die Datenverarbeitung?</LegalHeading>
        <LegalText>
          Ministerium für Verkehr Baden-Württemberg (VM)
          <br />
          Dorotheenstraße 8<br />
          70173 Stuttgart
          <br />
          Telefon: 0711 89686-0
          <br />
          Fax: 0711 89686-9020
          <br />
          Poststelle@vm.bwl.de
        </LegalText>

        <LegalHeading>
          2. Wie erreichen Sie unsere Datenschutzbeauftragte bzw. unseren Datenschutzbe- auftragten?
        </LegalHeading>
        <LegalText>
          Unsere Datenschutzbeauftragte bzw. unseren Datenschutzbeauftragten erreichen Sie postalisch über die unter
          Ziff. 1 angegebene Postanschrift oder unter folgenden E-Mail-Ad- ressen und Telefonnummern:
          <br />
          E-Mail: Datenschutz@vm.bwl.de Telefon: 0711 89686-0
        </LegalText>

        <LegalHeading>
          3. Was sind der Zweck und die Rechtsgrundlagen der Verarbeitung der personenbe- zogenen Daten?
          <br />
          <br />
          a) Zweck
        </LegalHeading>

        <LegalText>
          Wir verarbeiten Ihre Daten zur Erfassung und Bereitstellung von Verkehrszeichen des Landes BW im digitalen
          Verkehrszeichenkataster (VZK), als Grundlage für die Bearbeitung, Auswertung und Planung.
        </LegalText>

        <LegalHeading>b) Rechtsgrundlagen</LegalHeading>
        <LegalText>
          Die Verarbeitung erfolgt auf der Grundlage von Art. 6 Abs. 1 Buchstabe e) DS-GVO, § 4 Landesdatenschutzgesetz
          (LDSG) sowie § 53a Abs. 2 Buchst. a) und b) Straßengesetz (StrG) sowie Art. 6 Abs. 1 Buchstabe a) DSGVO.
        </LegalText>

        <LegalHeading>4. Welche personenbezogenen Daten werden verarbeitet?</LegalHeading>
        <LegalText>
          Wir erheben, verarbeiten und nutzen die Daten, die Sie uns im Rahmen der Anwendung und Nutzung des digitalen
          Verkehrszeichenkatasters, und/oder der Bearbeitung, Auswertung und Planung von Verkehrsinfrastruktur zur
          Verfügung stellen. Dazu gehören insbesondere:
        </LegalText>
        <ul>
          <li>
            Persönliche Kontaktdaten und Namen von Beschäftigten/Mitarbeitern von Landes- oder Kommunalverwaltungen (z.
            B. Vor- und Nachname, Adresse, E-Mail-Adresse, Telefonnummer).
          </li>
          <li>
            Persönliche Kontaktdaten und Namen von Ansprechpartnerinnen und Ansprechpartnern von Kunden/Unternehmen (z.
            B. Vor- und Nachname, Adresse, E-Mail-Adresse, Telefonnummer).
          </li>
          <li>Benutzername(n) und Passwort.</li>
          <li>Angaben zum Beschäftigungsverhältnis: (z.B. Funktion, Dienststelle, Dienstort, Organisationseinheit)</li>
          <li>
            Temporäre Nutzerdaten (z. B. IP-Adresse, zuvor besuchte Seite [Referrer URL], aufgerufene Seite, Typ und
            Version ihres Internet-Browsers, verwendetes Betriebssystem, Uhrzeit der Serveranfrage).
          </li>
        </ul>

        <LegalHeading>5. Woher stammen Ihre Daten?</LegalHeading>
        <LegalText>
          Wir verwenden vor allem die personenbezogenen Daten, die uns die zuständigen Behör- den und beteiligten
          Auftragnehmer (Unternehmen) im Rahmen der Nutzung des Verkehrs- infrastruktursystems und/oder der
          anschließenden Bearbeitung, Auswertung und Planung der Verkehrsinfrastruktur zur Verfügung stellen.
        </LegalText>

        <LegalHeading>6. Wie verarbeiten wir diese Daten?</LegalHeading>
        <LegalText>
          Ihre Daten werden bei der Anlage Ihres Benutzerkontos für das digitale Verkehrszeichen- kataster elektronisch
          für den Zeitraum der Nutzung des Systems (bis Löschung / Sperrung des Benutzerkontos) gespeichert.
          <br />
          Des Weiteren werden die Daten gespeichert, die Sie im Rahmen der Nutzung des VZK eigenverantwortlich selbst im
          System erfassen.
          <br />
          Zur Bearbeitung, Auswertung und Planung der Verkehrsinfrastruktur müssen zudem die mit der Ausführung
          beauftragten Personen/Unternehmen (z. B. Ingenieurbüros) im Notfall schnell erreichbar sein. Ihre Daten werden
          dazu elektronisch in der Datenbank der Fach- anwendung gespeichert.
          <br />
          Des Weiteren werden die beim Aufruf dieser Internetseite über Ihren Internetbrowser über- mittelten Daten
          (temporäre Nutzerdaten) während der laufenden Verbindung zur Kommu- nikation zwischen Ihrem Internetbrowser
          und dem BITBW-Webserver aufgezeichnet und nur für die Dauer des Besuchs der Internetseite gespeichert.
        </LegalText>

        <LegalHeading>7. Werden die personenbezogenen Daten weitergegeben?</LegalHeading>
        <LegalText>
          Die personenbezogenen Daten, die wir im Rahmen der gesetzlichen Verpflichtungen ver- arbeiten, geben wir nur
          dann an andere Stellen, Behörden oder Dritte weiter, wenn die Übermittlung gesetzlich zulässig, für die
          Erfüllung der vereinbarten Leistung erforderlich ist oder Sie in die Übermittlung eingewilligt haben.
        </LegalText>

        <LegalHeading>8. Besteht eine Pflicht zur Bereitstellung personenbezogener Daten?</LegalHeading>
        <LegalText>
          Hinsichtlich der Erfassung von Verkehrsdaten, der Bearbeitung, Auswertung und Planung der
          Verkehrsinfrastruktur sowie der Information daran Interessierter, besteht keine Pflicht zur Bereitstellung
          personenbezogener Daten. Die Daten sind jedoch erforder- lich, um die Verkehrsdaten zu erfassen / zu
          bearbeiten bzw. das digitale Verkehrszeichen- kataster nutzen zu können.
        </LegalText>

        <LegalHeading>9. Wie lange werden Ihre personenbezogenen Daten gespeichert?</LegalHeading>
        <LegalText>
          Die personenbezogenen Daten werden nur so lange gespeichert und die Akten so lange aufbewahrt, wie dies zur
          Erfüllung unserer Verpflichtungen bzw. gesetzlichen Aufgaben erforderlich ist.
          <br />
          Gemäß der Gemeinsamen Anordnung der Ministerien über die Verwaltung des Schriftguts der Behörden des Landes
          (AnO Schriftgut) werden die personenbezogenen Daten im Re- gelfall 10 Jahre aufbewahrt und gespeichert, soweit
          eine längere Speicherung nicht zur Verteidigung von Rechtsansprüchen erforderlich ist. Die Frist beginnt mit
          Ablauf des Jah- res, in dem der Vorgang abgeschlossen worden ist.
        </LegalText>

        <LegalHeading>10. Welche Rechte haben Sie als betroffene Person?</LegalHeading>
        <LegalText>
          Nach der Datenschutzgrundverordnung stehen Ihnen folgende Rechte zu:
          <br />
          <br />
          <br />
          a) Recht auf Widerspruch (Art. 21 DS-GVO) Soweit wir Ihre personenbezogenen Daten zur Wahrnehmung unserer
          öffentlichen Aufga- ben nach Art. 6 Abs. 1 Buchstabe e) DS-GVO verarbeiten, können Sie der künftigen Ver-
          arbeitung Ihrer Daten aus Gründen, die sich aus Ihrer besonderen Situation ergeben, je- derzeit widersprechen.
          Der Widerspruch ist an die für die Datenverarbeitung verantwortli- che Stelle (siehe Ziff. 1) zu richten.
          <br />
          <br />
          b) Recht auf Auskunft (Art. 15 DS-GVO) Sie haben das Recht, von uns Auskunft darüber zu erhalten, ob und -
          wenn ja - welche personenbezogenen Daten wir von Ihnen verarbeiten. Der Antrag ist bei der für die Daten-
          verarbeitung verantwortlichen Stelle (siehe Ziff. 1) zu stellen.
          <br />
          <br />
          c) Recht auf Berichtigung (Art. 16 DS-GVO) Sie können von uns unverzüglich die Berichtigung sie betreffender
          personenbezogener Daten verlangen, sofern diese nicht (mehr) zutreffend sind. Bei unvollständigen Daten ha-
          ben Sie – unter Berücksichtigung der Zwecke der Verarbeitung - einen Anspruch auf Ver- vollständigung. Der
          Antrag ist bei der für die Datenverarbeitung verantwortlichen Stelle (siehe Ziff. 1) zu stellen.
          <br />
          <br />
          d) Recht auf Löschung (Art. 17 DS-GVO) Bei Vorliegen der gesetzlichen Voraussetzungen können Sie die Löschung
          Ihrer perso- nenbezogenen Daten verlangen. Die Anfrage ist an die für die Datenverarbeitung verant- wortliche
          Stelle (siehe Ziff. 1) zu richten.
          <br />
          <br />
          e) Recht auf Einschränkung der Verarbeitung (Art. 18 DS-GVO) Unter den in Art. 18 DS-GVO genannten
          Voraussetzungen können Sie von uns die Ein- schränkung der Verarbeitung Ihrer personenbezogenen Daten
          verlangen. Die Anfrage ist an die für die Datenverarbeitung verantwortliche Stelle (siehe Ziff. 1) zu richten.
          <br />
          <br />
          f) Recht auf Datenübertragbarkeit (Art. 20 DS-GVO) Dieses Recht steht Ihnen nur bezüglich solcher
          personenbezogenen Daten zu, welche Sie uns selbst bereitgestellt haben. Sie können danach verlangen, dass wir
          Ihre Daten Ihnen selbst in einem maschinenlesbaren Format zur Verfügung stellen oder diese an einen an- deren
          Verantwortlichen übermitteln. Dieses Recht besteht jedoch nur, wenn Sie in die Da- tenverarbeitung
          eingewilligt haben (Art. 6 Abs. 1 Buchstabe a) oder Art. 9 Abs. 2 Buch- stabe a) DS-GVO) oder die Verarbeitung
          auf einem Vertrag gemäß Art. 6 Abs. 1 Buch- stabe b) DS-GVO beruht und die Datenverarbeitung mithilfe
          automatisierter Verfahren er- folgt. Dies gilt nicht, wenn die Verarbeitung der personenbezogenen Daten für
          die Wahr- nehmung einer Aufgabe erforderlich ist, im öffentlichen Interesse liegt oder in Ausübung
          öffentlicher Gewalt erfolgt, die den Regierungspräsidien übertragen wurde (Art. 6 Abs. 1 Buchstabe e) DS-GVO).
          Der Antrag ist bei der für die Datenverarbeitung verantwortlichen Stelle (siehe Ziff. 1) zu stellen
          <br />
          <br />
          g) Recht auf Widerruf der Einwilligung (Art. 7 Abs. 3 DS-GVO) Sofern die Verarbeitung Ihrer personenbezogenen
          Daten auf Ihrer Einwilligung beruht, ha- ben Sie das Recht, ihre Einwilligung jederzeit zu widerrufen. Durch
          den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten
          Verarbeitung nicht berührt. Der Widerruf ist an die für die Da- tenverarbeitung verantwortliche Stelle (siehe
          Ziff. 1) zu richten.
          <br />
          <br />
          h) Recht auf Beschwerde (Art. 77 Abs. 1 DS-GVO) Wenn Sie Fragen oder Bedenken im Hinblick auf die Verarbeitung
          Ihrer personenbezoge- nen Daten haben, können Sie das jeweilig verantwortliche Regierungspräsidium postalisch
          oder per E-Mail kontaktieren. Darüber hinaus können Sie Ihr Anliegen auch der bzw. dem behördlichen
          Datenschutzbeauftragten des jeweiligen Regierungspräsidiums zukommen las-sen. Die entsprechenden Adressen
          finden Sie unter Ziff. 2. Wenn Sie der Auffassung sind, dass wir unseren Pflichten nicht oder nicht in vollem
          Um- fang nachgekommen sind, können Sie unbeschadet anderweitiger Rechtsbehelfe eine Be- schwerde erheben bei
          dem Landesbeauftragten für den Datenschutz und die Informations- freiheit Baden-Württemberg (LfDI BW),
          Königstraße 10, 70173 Stuttgart.
        </LegalText>
        <br />
        <br />
        <br />

        <Typography>
          <b>Stand: 05.06.2023</b>
        </Typography>
      </>
    </ContainerLayout>
  );
}

export const Route = createFileRoute('/_authenticated/datenschutz')({
  component: PrivacyRoute,
});
